import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "relative items-center py-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { class: "whitespace-nowrap text-sm font-medium not-italic text-gray-800" }, "Device metadata", -1)
const _hoisted_3 = { class: "flex items-center justify-center" }
const _hoisted_4 = {
  key: 0,
  class: "flex justify-center align-middle"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_small_loader = _resolveComponent("small-loader")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_form_divider = _resolveComponent("form-divider")!
  const _component_button_wrapper = _resolveComponent("button-wrapper")!
  const _component_form_wrapper = _resolveComponent("form-wrapper")!
  const _component_modal_component = _resolveComponent("modal-component")!

  return (_openBlock(), _createBlock(_component_modal_component, {
    "is-displayed": _ctx.isCreateRelationModalOpened,
    "no-padding": true,
    title: "Create device metadata relation",
    onToggleModal: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('toggle-modal')))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_form_wrapper, { "is-form-in-modal": true }, {
        default: _withCtx(() => [
          _createElementVNode("form", {
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
          }, [
            _createVNode(_component_form_divider, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _hoisted_2,
                  _createElementVNode("div", _hoisted_3, [
                    (_ctx.isLoading)
                      ? (_openBlock(), _createBlock(_component_small_loader, {
                          key: 0,
                          height: "h-8",
                          width: "w-8"
                        }))
                      : (_openBlock(), _createBlock(_component_v_select, {
                          key: 1,
                          modelValue: _ctx.deviceMetadataId,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.deviceMetadataId) = $event)),
                          class: _normalizeClass(`mt-1 w-full`),
                          options: _ctx.paginatedDeviceMetadata.items,
                          reduce: (metadata) => metadata.id,
                          label: "name",
                          clearable: false,
                          onInput: _ctx.handleDeviceMetadataSearch,
                          onClose: _ctx.handleDropdownClose
                        }, {
                          "list-footer": _withCtx(() => [
                            (_ctx.paginatedDeviceMetadata.hasNextPage)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "mt-1 cursor-pointer bg-primary px-3 py-1 text-white transition duration-300 hover:bg-primaryhover disabled:cursor-not-allowed",
                                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.loadMoreDeviceMetadata && _ctx.loadMoreDeviceMetadata(...args)))
                                  }, " Load more... ")
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["modelValue", "options", "reduce", "onInput", "onClose"]))
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_button_wrapper)
          ], 32)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["is-displayed"]))
}